var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center", id: "gridDetalle" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" }
                },
                [
                  _c(
                    "v-container",
                    {
                      staticStyle: { padding: "30px 40px 50px 40px" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-flex", { attrs: { md12: "" } }, [
                            _c(
                              "table",
                              {
                                attrs: {
                                  id: "tablaProducto",
                                  "aria-hidden": "true"
                                }
                              },
                              [
                                _c("thead", [
                                  _c("tr", [
                                    _c(
                                      "th",
                                      {
                                        staticClass: "text-left",
                                        attrs: { id: "thNombre" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      Nombre de Producto\n                    "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "th",
                                      {
                                        staticClass: "text-left",
                                        attrs: { id: "thPrecio" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      Precio de la Unidad\n                    "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "th",
                                      {
                                        staticClass: "text-left",
                                        attrs: { id: "thCantidad" }
                                      },
                                      [_vm._v("Cantidad")]
                                    ),
                                    _c(
                                      "th",
                                      {
                                        staticClass: "text-left",
                                        attrs: { id: "thDescuento" }
                                      },
                                      [_vm._v("Descuento")]
                                    ),
                                    _c(
                                      "th",
                                      {
                                        staticClass: "text-left",
                                        attrs: { id: "thValorNeto" }
                                      },
                                      [_vm._v("Valor Neto")]
                                    )
                                  ])
                                ]),
                                _c(
                                  "tbody",
                                  _vm._l(_vm.facturaSeleccionada, function(
                                    item
                                  ) {
                                    return _c("tr", { key: item.name }, [
                                      _c("td", [
                                        _vm._v(_vm._s(item.NombreItem))
                                      ]),
                                      _c("td", { staticClass: "tdAlign" }, [
                                        _vm._v(
                                          "\n                      $ " +
                                            _vm._s(
                                              item.PrecioItem.toLocaleString()
                                            ) +
                                            "\n                    "
                                        )
                                      ]),
                                      _c("td", { staticClass: "tdAlign" }, [
                                        _vm._v(_vm._s(item.CantidadItem))
                                      ]),
                                      item.Descuento === "null"
                                        ? _c("td", { staticClass: "tdAlign" }, [
                                            _vm._v(
                                              "\n                      $ " +
                                                _vm._s(item.Descuento) +
                                                "\n                    "
                                            )
                                          ])
                                        : _c("td", { staticClass: "tdAlign" }, [
                                            _vm._v("$ 0")
                                          ]),
                                      _c("td", { staticClass: "tdAlign" }, [
                                        _vm._v(
                                          "\n                      $ " +
                                            _vm._s(
                                              item.MontoItem.toLocaleString()
                                            ) +
                                            "\n                    "
                                        )
                                      ])
                                    ])
                                  }),
                                  0
                                )
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }